import axios from 'axios'

/* eslint-disable import/no-internal-modules */
import { publish } from '@insided/deprecated-utils/globals'

export async function markPostsAsSpam(posts: Object[]) {
    await axios.post('/community/api/bulk/process', {
        action: 'markAsSpam',
        topics: posts
    })

    await axios.post('/community/api/invalidateCache?apiPath=spamContent/count')
    publish('posts_marked_as_spam', {})
}

export async function markPostsAsNotSpam(posts: Object[]) {
    await axios.post('/community/api/bulk/process', {
        action: 'markAsNotSpam',
        topics: posts
    })

    await axios.post('/community/api/invalidateCache?apiPath=spamContent/count')
    publish('posts_marked_as_not_spam', {})
}
